/* eslint-disable @typescript-eslint/no-explicit-any */
import { Checkbox } from 'antd';
import { MergedProperty } from '../../types';

interface TableBoxItemProps {
    item: MergedProperty;
    onChange: (value: any, code: string) => void;
}

const TableBoxItem = ({ item, onChange }: TableBoxItemProps) => (
    <tr>
        <td className="text-center">{item?.sortOrder}</td>
        <td data-label="Tên báo cáo">{item?.p_name}</td>
        <td data-label="Tên phân hệ">{item?.category}</td>
        <td className="text-center">
            <Checkbox
                checked={!!item?.ps_value}
                onChange={() => onChange(!item.ps_value, item.ps_code)}
            />
        </td>
    </tr>
);

export default TableBoxItem;
